export interface TextTable {
	[k: string]: TextGroup
}

export interface TextGroup {
	[k: string]: string
}

export function getText(texts: TextTable, group: string, key: string, defaultText?: string): string {
	const textValue = texts[group]?.[key]
	return textValue || defaultText || `${group}.${key || ''}`
}
